var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundGrouped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1701,
    height: 811,
    viewBox: "0 0 1701 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    clipPath: "url(#clip0_8_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1528.86 322.086C1679.08 322.086 1800.86 200.334 1800.86 50.1439C1800.86 -100.046 1679.08 -221.799 1528.86 -221.799C1378.64 -221.799 1256.86 -100.046 1256.86 50.1439C1256.86 200.334 1378.64 322.086 1528.86 322.086Z",
    fill: "url(#paint0_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.76 215.727C1227.78 215.727 1237.52 205.986 1237.52 193.971C1237.52 181.956 1227.78 172.216 1215.76 172.216C1203.74 172.216 1194 181.956 1194 193.971C1194 205.986 1203.74 215.727 1215.76 215.727Z",
    fill: "url(#paint1_radial_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.08 363.18C1309.78 363.18 1328.19 344.782 1328.19 322.086C1328.19 299.391 1309.78 280.993 1287.08 280.993C1264.38 280.993 1245.98 299.391 1245.98 322.086C1245.98 344.782 1264.38 363.18 1287.08 363.18Z",
    fill: "url(#paint2_radial_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.5 512.227C1815.61 438.775 1833.15 302.149 1759.68 207.063C1686.21 111.977 1549.56 94.4391 1454.45 167.891C1359.35 241.342 1341.8 377.969 1415.27 473.054C1488.74 568.14 1625.39 585.678 1720.5 512.227Z",
    fill: "url(#paint3_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1271.35 287.805C1234.04 368.264 1269.03 463.73 1349.51 501.034C1429.98 538.338 1525.47 503.353 1562.78 422.894C1600.09 342.434 1565.1 246.968 1484.62 209.664C1404.15 172.36 1308.66 207.345 1271.35 287.805Z",
    stroke: "url(#paint4_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1732.86 512.387C1836.65 452.479 1872.21 319.794 1812.29 216.029C1752.37 112.263 1619.65 76.7107 1515.87 136.62C1412.08 196.529 1376.52 329.213 1436.44 432.978C1496.36 536.744 1629.07 572.296 1732.86 512.387Z",
    stroke: "url(#paint5_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1308.4 229.221C1247.31 293.987 1250.31 396 1315.09 457.074C1379.87 518.147 1481.9 515.153 1542.99 450.387C1604.08 385.62 1601.08 283.607 1536.3 222.534C1471.52 161.46 1369.49 164.454 1308.4 229.221Z",
    fill: "url(#paint6_linear_8_2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9895 658.645C39.948 651.717 120.339 649.857 178.233 697.834C250.602 757.806 272.48 764.931 313.714 770.276C354.947 775.62 400.808 790.465 430.682 824.309",
    stroke: "url(#paint7_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.2412 658.645C6.71729 651.717 87.108 649.857 145.003 697.834C217.371 757.806 239.25 764.931 280.483 770.276C321.717 775.62 367.577 790.465 397.451 824.309",
    stroke: "url(#paint8_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.0325 658.645C-30.074 651.717 50.3167 649.857 108.212 697.834C180.58 757.806 202.458 764.931 243.692 770.276C284.925 775.62 330.786 790.465 360.659 824.309",
    stroke: "url(#paint9_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.5 650.07C-80.8714 644.116 5.6179 644.623 66.5486 694.286C142.712 756.367 166.041 764.133 210.228 770.689C254.417 777.245 303.32 793.434 334.51 828.147",
    stroke: "url(#paint10_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M268.274 701.908C299.973 694.362 319.539 662.605 311.975 630.979C304.411 599.352 272.581 579.831 240.881 587.378C209.181 594.925 189.616 626.681 197.18 658.308C204.744 689.935 236.574 709.455 268.274 701.908Z",
    stroke: "url(#paint11_linear_8_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.099 698.512C289.284 698.512 312.132 675.717 312.132 647.597C312.132 619.477 289.284 596.682 261.099 596.682C232.914 596.682 210.066 619.477 210.066 647.597C210.066 675.717 232.914 698.512 261.099 698.512Z",
    fill: "url(#paint12_radial_8_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_2",
    x1: 1128.12,
    y1: -241.137,
    x2: 1462.27,
    y2: 322.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1215.76 193.971) rotate(90) scale(21.7554 21.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#4A6CF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1287.08 322.086) rotate(90) scale(41.0935 41.1022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#4A6CF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_2",
    x1: 1220.32,
    y1: 60.0243,
    x2: 1591.4,
    y2: 411.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_2",
    x1: 1563.33,
    y1: 423.148,
    x2: 1270.82,
    y2: 287.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_2",
    x1: 1515.56,
    y1: 136.096,
    x2: 1733.1,
    y2: 512.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8_2",
    x1: 1726.82,
    y1: 502.203,
    x2: 1414.58,
    y2: 288.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8_2",
    x1: 218.835,
    y1: 654.986,
    x2: 218.835,
    y2: 824.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8_2",
    x1: 185.605,
    y1: 654.986,
    x2: 185.605,
    y2: 824.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8_2",
    x1: 148.813,
    y1: 654.986,
    x2: 148.813,
    y2: 824.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8_2",
    x1: 111.383,
    y1: 652.65,
    x2: 106.749,
    y2: 821.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8_2",
    x1: 240.743,
    y1: 586.802,
    x2: 263.14,
    y2: 690.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A6CF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_8_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.099 647.597) rotate(90) scale(50.9154 51.033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 544,
    height: 672,
    fill: "white",
    transform: "translate(1194 -26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 238,
    fill: "white",
    transform: "translate(0 573)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGrouped);
export default __webpack_public_path__ + "static/media/background-grouped.137bbf0b2375ce70b50893b090ed7381.svg";
export { ForwardRef as ReactComponent };